module.exports = __webpack_public_path__ + "static/img/SmileAnimation_blueberrypomegranate.0e904fd.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/smiles/SmileAnimation_blueberrypomegranate.gif
// module id = I/06
// module chunks = 0